import React from "react";

const FujairahAreas = ({ title, description, areas }) => {
  return (
    <section className="ft-areas-section">
      <div className="container">
        <div
          className="text-center mb-5"
          data-aos="fade-up"
          data-aos-once="true"
        >
          <h2>{title}</h2>
          {description && <p>{description}</p>}
        </div>

        <div className="row g-4">
          {areas.map((area, i) => (
            <div
              key={i}
              className="col-md-6 col-lg-4"
              data-aos="fade-up"
              data-aos-delay={`${(i % 3) * 100}`}
              data-aos-duration="700"
              data-aos-once="true"
            >
              <div className="ft-area-card">
                <div className="ft-area-card-header">
                  <i className="bi bi-geo-alt-fill"></i>
                  <span>{area.title}</span>
                </div>
                <p className="ft-area-card-desc">{area.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FujairahAreas;
